
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'documents-public-ui',
  currentProjectVersion: 'static-1.33594',
  depVersions: {
  "documents-public-ui": "static-1.33594",
  "client-types": "static-1.437",
  "documents-lib": "static-1.33599",
  "emoji-mart": "static-3.4",
  "foundations-theming-specialty": "static-1.1780",
  "googlemaps-react-wrapper": "static-1.3",
  "head-dlb": "static-1.4702",
  "highcharts": "static-8.97",
  "hs-promise-utils": "static-1.5253",
  "hs-test-utils": "static-1.7647",
  "hub-http": "static-1.5872",
  "hubspot-dlb": "static-2.1773",
  "HubStyleTokens": "static-2.11082",
  "I18n": "static-7.1533",
  "jasmine-immutable": "static-1.2674",
  "jasmine-runner": "static-1.6116",
  "lodash": "static-1.3",
  "quartz": "static-1.6525",
  "react": "static-7.174",
  "react-dlb": "static-1.68",
  "react-dnd": "static-3.19",
  "react-dnd-html5-backend": "static-3.7",
  "react-redux": "static-7.65",
  "react-rhumb": "static-1.16288",
  "reporting-data": "static-1.65916",
  "reporting-testing-lib": "static-1.7850",
  "reporting-visualizations": "static-1.57993",
  "tinymce": "static-6.5",
  "ui-addon-draggable": "static-3.4408",
  "webpack-env": "static-1.54",
  "atom": "static-1.4737",
  "autolinker": "static-3.11",
  "avatar-components": "static-1.2124",
  "classnames": "static-2.10",
  "crm_schema": "static-3.90820",
  "cssUtils": "static-1.687",
  "customer-data-filters-ui": "static-1.38383",
  "customer-data-objects": "static-1.7274",
  "customer-data-property-utils": "static-1.7728",
  "data-fetching-client": "static-1.9338",
  "enviro": "static-4.371",
  "FireAlarmUi": "static-1.4199",
  "flux-actions": "static-1.294",
  "FormsCommonComponents": "static-1.84873",
  "FormUrlGenerator": "static-2.4396",
  "foundations-components": "static-1.7219",
  "history": "static-4.47",
  "hs-lodash": "static-4.45",
  "hubspot-url-utils": "static-1.3825",
  "HubStyle": "static-2.11390",
  "icons": "static-2.605",
  "immutable": "static-2.19",
  "isMobile": "static-1.7",
  "js-cookie": "static-1.18",
  "laboratory-lib": "static-3.6803",
  "metrics-js": "static-1.9296",
  "PatternValidationJS": "static-1.437",
  "pdf-js": "static-2.49",
  "PortalIdParser": "static-2.334",
  "property-description-translator": "static-1.3524",
  "property-translator": "static-1.5078",
  "quartz-config": "static-1.303",
  "quartz-core": "static-1.5744",
  "quick-fetch": "static-1.3600",
  "raven": "static-3.5564",
  "react-dom": "static-7.85",
  "react-immutable-proptypes": "static-2.8",
  "react-input-autosize": "static-2.17",
  "react-router-dom": "static-5.26",
  "react-select-plus": "static-1.65",
  "react-utils": "static-2.5051",
  "react-virtualized": "static-2.91",
  "redux": "static-4.16",
  "redux-thunk": "static-2.43",
  "reference-resolvers": "static-1.7822",
  "reference-resolvers-lite": "static-1.7755",
  "report-customization-components": "static-1.12134",
  "reporting-enablement": "static-1.21613",
  "reporting-reports": "static-1.65595",
  "reporting-snowflake": "static-1.54535",
  "reporting-ui-components": "static-2.63189",
  "reselect": "static-2.16",
  "rpc-client-utils": "static-1.4266",
  "sales-content-partitioning": "static-1.8599",
  "SalesContentIndexUI": "static-3.8693",
  "sanitize": "static-1.4139",
  "sanitize-text": "static-1.7804",
  "self-service-api": "static-1.9886",
  "SharedI18nStrings": "static-1.179",
  "SharedLegalStrings": "static-1.1449",
  "signup-constants": "static-1.18103",
  "signup-ui-lego-core": "static-1.20113",
  "signup-ui-url-generator": "static-2.7711",
  "styled-components": "static-2.83",
  "StyleGuideUI": "static-3.481",
  "superstore": "static-1.4432",
  "transmute": "static-2.77",
  "ui-addon-form-validation": "static-1.10660",
  "ui-addon-i18n": "static-1.10789",
  "ui-addon-react-router-dom": "static-1.9204",
  "ui-addon-upgrades": "static-9.17363",
  "ui-asset-management-lib": "static-1.10508",
  "ui-images": "static-2.1047",
  "UIComponents": "static-3.8029",
  "usage-tracker": "static-1.6999",
  "usage-tracker-container": "static-1.6989",
  "usage-tracker-core": "static-1.6849",
  "usage-tracker-public": "static-1.6810",
  "viral-links-lib": "static-1.6676",
  "hs-promise-rejection-tracking": "static-1.5234",
  "raven-hubspot": "static-1.5871",
  "hoist-non-react-statics": "static-3.9",
  "bend-plugin-trellis-migration": "static-1.3099",
  "moment": "static-3.26",
  "bend-plugin-quartz": "static-1.2802",
  "quartz-webpack": "static-1.2749",
  "ai-components-ui-library": "static-1.7991",
  "amplitude-session-replay-browser": "static-1.53",
  "foundations-assets": "static-1.4492",
  "foundations-theming": "static-1.4064",
  "react-transition-group": "static-1.7",
  "usage-tracker-session-replay": "static-1.4685",
  "foundations-theming-base": "static-1.3049",
  "HeadJS": "static-2.682",
  "framer-motion": "static-1.62",
  "hs-test-utils-bend-plugin": "static-1.2758",
  "msw": "static-1.39",
  "testing-library": "static-1.145",
  "i18n-data": "static-1.214",
  "moment-timezone": "static-5.76",
  "jasmine": "static-4.3997",
  "csstype": "static-1.50",
  "frontend-preferences-client": "static-1.7587",
  "graphql": "static-1.75",
  "immer": "static-1.33",
  "inbound-db-meta-service-client": "static-1.3332",
  "persist-promise": "static-1.3348",
  "reporting-client-types": "static-1.2339",
  "hs-story-utils": "static-1.9094",
  "react-flip-move": "static-1.63",
  "hub-http-shared-msw-handlers": "static-1.9129",
  "hubspotter-http": "static-1.4350",
  "sassPrefix": "static-1.149",
  "conversations-skeleton-state": "static-1.6915",
  "crm-message-bus": "static-1.41969",
  "customer-data-filters-ui-msw-helpers": "static-1.20817",
  "customer-data-objects-ui-components": "static-1.12664",
  "customer-data-reference-ui-components": "static-1.12788",
  "customer-data-ui-utilities": "static-1.9487",
  "framework-builder-read-service-client": "static-1.3720",
  "framework-data-schema-quick-fetch": "static-1.6432",
  "framework-data-schema-resolvers": "static-1.6527",
  "inbound-db-properties-service-client": "static-1.3553",
  "multi-account-reference-resolvers": "static-1.627",
  "onboarding-tours": "static-1.16075",
  "reporting-datasets-permissions-lib": "static-1.12604",
  "ui-addon-teams": "static-1.21032",
  "apollo-stack-hubspot": "static-3.79",
  "fast-json-stable-stringify": "static-1.4",
  "ContentUtils": "static-1.67181",
  "customer-data-properties": "static-1.50369",
  "forms-ai-lib": "static-1.3778",
  "forms-utils-lib": "static-1.11909",
  "foundations-components-test-utils": "static-1.4702",
  "react-dnd-compat": "static-1.4289",
  "react-tinymce": "static-1.54243",
  "tinymce-config": "static-2.53369",
  "ui-gdpr-components": "static-1.10009",
  "underscore": "static-1.8",
  "bend-plugin-foundations-components": "static-1.3488",
  "floating-ui": "static-1.49",
  "react-aria": "static-1.58",
  "tanstack-table": "static-1.48",
  "trellis-assets": "static-1.911",
  "ui-fonts": "static-1.344",
  "dispatcher": "static-1.129",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.762",
  "mobile-manifest-mixins": "static-1.455",
  "quartz-auth": "static-1.200",
  "quartz-head": "static-1.190",
  "quartz-i18n": "static-1.200",
  "quartz-test": "static-1.200",
  "batch-promise": "static-1.1191",
  "external-options-client-types": "static-1.3855",
  "react-colorpicker": "static-2.9878",
  "reporting-insights-lib": "static-1.767",
  "copilot-toolkit": "static-1.10183",
  "data-quality-ui-library": "static-1.12012",
  "html-to-image": "static-1.47",
  "markdown-it": "static-1.6",
  "reporting-action-components": "static-1.40340",
  "reporting-plugins": "static-1.9796",
  "ui-addon-draggable-compat": "static-2.3918",
  "ui-addon-opt": "static-4.8053",
  "ui-shepherd-react": "static-3.9803",
  "zustand": "static-1.51",
  "growth-payments-core": "static-1.24334",
  "hubspot-apollo-client": "static-1.4542",
  "sales-templates-service-types-lib": "static-1.3867",
  "ui-business-units-lib": "static-1.8671",
  "growth-monetization-service-types": "static-1.4198",
  "merchandise-lib": "static-1.253",
  "emoji-regex": "static-1.7",
  "feature-store-service-types": "static-1.4191",
  "purchase-motions-components": "static-1.5275",
  "salesImages": "static-1.518",
  "ts-schema": "static-1.3777",
  "upgrade-management-service-types": "static-1.4182",
  "timezone-utils": "static-2.4907",
  "bender-build-tools": "static-1.2770",
  "chatspot-core": "static-1.19790",
  "bend-plugin-foundations-theming": "static-1.2547",
  "stylex": "static-1.25",
  "react-immutable-render-mixin": "static-1.9",
  "conditional-properties-service-client": "static-1.3494",
  "crm-pipelines-api-client-types": "static-1.3838",
  "multi-currency-client-types": "static-1.3394",
  "getting-started-shared-tasks": "static-1.17465",
  "growth-data-modal": "static-1.4993",
  "growth-onboarding-confetti": "static-1.2716",
  "growth-onboarding-next-action-utils": "static-1.1151",
  "navigation-components": "static-1.16880",
  "onboarding-tours-client": "static-1.4289",
  "onboarding-tours-utils": "static-1.141",
  "ui-shepherd-tracker": "static-1.7184",
  "ui-universal-auth": "static-1.8498",
  "user-context": "static-1.4751",
  "cms-field-types": "static-1.4467",
  "content-icons-ui": "static-1.2103",
  "calling-global-api": "static-1.63185",
  "calling-internal-common": "static-1.30950",
  "calling-lifecycle-internal": "static-1.64567",
  "calling-lifecycle-messages": "static-1.56861",
  "commerce-products-lib": "static-1.8429",
  "crm-links": "static-1.5908",
  "file-manager-components": "static-1.22491",
  "google-libphonenumber": "static-1.31",
  "hs-entities": "static-1.312",
  "inbounddb-objects-service-types": "static-1.3922",
  "meetings-icalendar-utils-lib": "static-1.298",
  "object-builder-ui-client": "static-1.47507",
  "pipeline-validation-client-types": "static-1.3658",
  "property-value-citations": "static-1.983",
  "pulse": "static-1.145",
  "smart-property-lib": "static-1.5379",
  "tiered-pricing": "static-1.613",
  "ui-addon-iframeable": "static-1.8668",
  "final-form": "static-1.63",
  "redux-mock-store": "static-1.8",
  "redux-toolkit": "static-1.7",
  "rich-text-lib": "static-1.19234",
  "tinymce-themes": "static-1.55339",
  "data-token-picker": "static-1.15824",
  "hub-http-contrib": "static-1.2711",
  "interframe": "static-3.4453",
  "tinymce-data": "static-1.39454",
  "tinymce-plugins": "static-1.56483",
  "ui-addon-sales-email": "static-1.4879",
  "hubspotter-http-shared-msw-handlers": "static-1.9127",
  "magpie-lib": "static-1.5237",
  "magpie-types": "static-1.4697",
  "simple-logging-lib": "static-1.2714",
  "content-assistance-lib": "static-1.7250",
  "dashboard-lib": "static-1.80086",
  "ExportDialog": "static-6.10051",
  "hubspot-prosemirror": "static-1.17236",
  "hubspot-prosemirror-plugins": "static-1.17228",
  "integrations-lib": "static-1.14976",
  "prosemirror": "static-1.13",
  "share-with-third-party-component-lib": "static-1.8351",
  "campaign-roi-lib": "static-1.7878",
  "feedback-loader": "static-1.28619",
  "commerce-analytics-service-client": "static-1.3346",
  "onboarding-scopes": "static-1.6106",
  "apollo-link-hub-http": "static-2.4312",
  "nav-client-types": "static-1.1996",
  "purchase-motions-api": "static-1.5278",
  "trials-service-types": "static-1.3599",
  "chatspot-client-types": "static-1.10306",
  "idb-keyval": "static-1.37",
  "reactive-lib": "static-1.390",
  "getting-started-shared-tasks-store": "static-1.16583",
  "calling-error-reporting": "static-1.30956",
  "shared-worker-versioning": "static-1.10680",
  "calling-usage-tracker": "static-1.6203",
  "calling-orchestration-shared-library": "static-1.34374",
  "customer-data-tracking": "static-1.6525",
  "products-iframe-lib": "static-1.6989",
  "products-ui-components-shared-msw-handlers": "static-1.9511",
  "location-customization-utils-lib": "static-1.8118",
  "apollo-dlb": "static-3.80",
  "immerable": "static-1.3819",
  "video-components-external": "static-1.10145",
  "video-data-lib": "static-1.33803",
  "directed-graph": "static-1.598",
  "event-emitter": "static-1.589",
  "breeze-intelligence-kit": "static-1.5122",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.9212",
  "fsm": "static-1.3393",
  "policy-lib": "static-1.6466",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.9275",
  "navigation-messaging": "static-1.6207",
  "FileManagerLib": "static-1.38131",
  "NamespacedHubStyle": "static-2.8775",
  "FileManagerCore": "static-1.37990",
  "codemirror": "static-5.88",
  "layout-dnd-components": "static-1.11794",
  "layout-dnd-utils": "static-1.10769",
  "react-codemirror": "static-1.10266",
  "ui-addon-emoji-picker": "static-1.9555",
  "ui-brand-identity-lib": "static-1.13318",
  "ui-addon-video-player": "static-1.8386",
  "ui-coaching-tips": "static-1.27561",
  "redux-actions": "static-3.7",
  "knowledge-content-types": "static-1.8264",
  "payment-link-components": "static-1.22561",
  "EmailSignatureEditor": "static-1.23677",
  "integrations-error-boundary-lib": "static-1.12391",
  "integrations-tracking-lib": "static-1.5247",
  "native-integrations-shared-strings": "static-1.7449",
  "redux-observable": "static-1.11",
  "ReduxMessenger": "static-2.10038",
  "rxjs": "static-5.10",
  "eligibility-engine-service-types": "static-1.2880",
  "calling-orchestration-schema": "static-1.34599",
  "sales-views-client-types": "static-1.3955",
  "crm-record-cards-service-types": "static-1.3332",
  "content-media-composition-data-lib": "static-1.10866",
  "content-media-compositions": "static-2.14873",
  "media-bridge-lib": "static-1.18350",
  "trellis-story-utils": "static-1.4188",
  "storybook-react": "static-1.26",
  "audio-components": "static-1.5419",
  "FileManagerImages": "static-1.35642",
  "video-components": "static-1.12148",
  "cropperjs": "static-1.10",
  "urlinator": "static-1.4189",
  "video-embed": "static-1.34637",
  "diff-match-patch": "static-1.7",
  "ContentData": "static-1.67256",
  "layout-data-lib": "static-1.9094",
  "browser-eslint": "static-2.57",
  "growth-onboarding-feedback-components": "static-1.6250",
  "commerce-tours-lib": "static-1.5508",
  "growth-onboarding-reliability": "static-1.4752",
  "sales-checkout-service-client": "static-1.3358",
  "draft-convert": "static-2.31",
  "draft-extend": "static-2.46",
  "draft-js": "static-5.37",
  "draft-plugins": "static-2.21074",
  "sales-email-signature-service-client": "static-1.3503",
  "universal-page-editor-lib": "static-1.2660",
  "hls.js": "static-1.32",
  "social-insights-client-types": "static-1.21028",
  "outpost": "static-1.3880",
  "advanced-menus-core": "static-1.14600",
  "advanced-menus-lib": "static-1.11601",
  "ui-memberships-settings-lib": "static-1.33052",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.14599",
  "simple-menus-lib": "static-1.16116"
},
  depPathPrefixes: {
  "documents-public-ui": "/documents-public-ui/static-1.33594",
  "client-types": "/client-types/static-1.437",
  "documents-lib": "/documents-lib/static-1.33599",
  "emoji-mart": "/emoji-mart/static-3.4",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.1780",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "head-dlb": "/head-dlb/static-1.4702",
  "highcharts": "/highcharts/static-8.97",
  "hs-promise-utils": "/hs-promise-utils/static-1.5253",
  "hs-test-utils": "/hs-test-utils/static-1.7647",
  "hub-http": "/hub-http/static-1.5872",
  "hubspot-dlb": "/hubspot-dlb/static-2.1773",
  "HubStyleTokens": "/HubStyleTokens/static-2.11082",
  "I18n": "/I18n/static-7.1533",
  "jasmine-immutable": "/jasmine-immutable/static-1.2674",
  "jasmine-runner": "/jasmine-runner/static-1.6116",
  "lodash": "/lodash/static-1.3",
  "quartz": "/quartz/static-1.6525",
  "react": "/react/static-7.174",
  "react-dlb": "/react-dlb/static-1.68",
  "react-dnd": "/react-dnd/static-3.19",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-3.7",
  "react-redux": "/react-redux/static-7.65",
  "react-rhumb": "/react-rhumb/static-1.16288",
  "reporting-data": "/reporting-data/static-1.65916",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.7850",
  "reporting-visualizations": "/reporting-visualizations/static-1.57993",
  "tinymce": "/tinymce/static-6.5",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4408",
  "webpack-env": "/webpack-env/static-1.54",
  "atom": "/atom/static-1.4737",
  "autolinker": "/autolinker/static-3.11",
  "avatar-components": "/avatar-components/static-1.2124",
  "classnames": "/classnames/static-2.10",
  "crm_schema": "/crm_schema/static-3.90820",
  "cssUtils": "/cssUtils/static-1.687",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.38383",
  "customer-data-objects": "/customer-data-objects/static-1.7274",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.7728",
  "data-fetching-client": "/data-fetching-client/static-1.9338",
  "enviro": "/enviro/static-4.371",
  "FireAlarmUi": "/FireAlarmUi/static-1.4199",
  "flux-actions": "/flux-actions/static-1.294",
  "FormsCommonComponents": "/FormsCommonComponents/static-1.84873",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.4396",
  "foundations-components": "/foundations-components/static-1.7219",
  "history": "/history/static-4.47",
  "hs-lodash": "/hs-lodash/static-4.45",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.3825",
  "HubStyle": "/HubStyle/static-2.11390",
  "icons": "/icons/static-2.605",
  "immutable": "/immutable/static-2.19",
  "isMobile": "/isMobile/static-1.7",
  "js-cookie": "/js-cookie/static-1.18",
  "laboratory-lib": "/laboratory-lib/static-3.6803",
  "metrics-js": "/metrics-js/static-1.9296",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "pdf-js": "/pdf-js/static-2.49",
  "PortalIdParser": "/PortalIdParser/static-2.334",
  "property-description-translator": "/property-description-translator/static-1.3524",
  "property-translator": "/property-translator/static-1.5078",
  "quartz-config": "/quartz-config/static-1.303",
  "quartz-core": "/quartz-core/static-1.5744",
  "quick-fetch": "/quick-fetch/static-1.3600",
  "raven": "/raven/static-3.5564",
  "react-dom": "/react-dom/static-7.85",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "react-router-dom": "/react-router-dom/static-5.26",
  "react-select-plus": "/react-select-plus/static-1.65",
  "react-utils": "/react-utils/static-2.5051",
  "react-virtualized": "/react-virtualized/static-2.91",
  "redux": "/redux/static-4.16",
  "redux-thunk": "/redux-thunk/static-2.43",
  "reference-resolvers": "/reference-resolvers/static-1.7822",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.7755",
  "report-customization-components": "/report-customization-components/static-1.12134",
  "reporting-enablement": "/reporting-enablement/static-1.21613",
  "reporting-reports": "/reporting-reports/static-1.65595",
  "reporting-snowflake": "/reporting-snowflake/static-1.54535",
  "reporting-ui-components": "/reporting-ui-components/static-2.63189",
  "reselect": "/reselect/static-2.16",
  "rpc-client-utils": "/rpc-client-utils/static-1.4266",
  "sales-content-partitioning": "/sales-content-partitioning/static-1.8599",
  "SalesContentIndexUI": "/SalesContentIndexUI/static-3.8693",
  "sanitize": "/sanitize/static-1.4139",
  "sanitize-text": "/sanitize-text/static-1.7804",
  "self-service-api": "/self-service-api/static-1.9886",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.179",
  "SharedLegalStrings": "/SharedLegalStrings/static-1.1449",
  "signup-constants": "/signup-constants/static-1.18103",
  "signup-ui-lego-core": "/signup-ui-lego-core/static-1.20113",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.7711",
  "styled-components": "/styled-components/static-2.83",
  "StyleGuideUI": "/StyleGuideUI/static-3.481",
  "superstore": "/superstore/static-1.4432",
  "transmute": "/transmute/static-2.77",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.10660",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.10789",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9204",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.17363",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.10508",
  "ui-images": "/ui-images/static-2.1047",
  "UIComponents": "/UIComponents/static-3.8029",
  "usage-tracker": "/usage-tracker/static-1.6999",
  "usage-tracker-container": "/usage-tracker-container/static-1.6989",
  "usage-tracker-core": "/usage-tracker-core/static-1.6849",
  "usage-tracker-public": "/usage-tracker-public/static-1.6810",
  "viral-links-lib": "/viral-links-lib/static-1.6676",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5234",
  "raven-hubspot": "/raven-hubspot/static-1.5871",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3099",
  "moment": "/moment/static-3.26",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.2802",
  "quartz-webpack": "/quartz-webpack/static-1.2749",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.7991",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.53",
  "foundations-assets": "/foundations-assets/static-1.4492",
  "foundations-theming": "/foundations-theming/static-1.4064",
  "react-transition-group": "/react-transition-group/static-1.7",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.4685",
  "foundations-theming-base": "/foundations-theming-base/static-1.3049",
  "HeadJS": "/HeadJS/static-2.682",
  "framer-motion": "/framer-motion/static-1.62",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.2758",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.145",
  "i18n-data": "/i18n-data/static-1.214",
  "moment-timezone": "/moment-timezone/static-5.76",
  "jasmine": "/jasmine/static-4.3997",
  "csstype": "/csstype/static-1.50",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.7587",
  "graphql": "/graphql/static-1.75",
  "immer": "/immer/static-1.33",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3332",
  "persist-promise": "/persist-promise/static-1.3348",
  "reporting-client-types": "/reporting-client-types/static-1.2339",
  "hs-story-utils": "/hs-story-utils/static-1.9094",
  "react-flip-move": "/react-flip-move/static-1.63",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.9129",
  "hubspotter-http": "/hubspotter-http/static-1.4350",
  "sassPrefix": "/sassPrefix/static-1.149",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.6915",
  "crm-message-bus": "/crm-message-bus/static-1.41969",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.20817",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.12664",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.12788",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9487",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.3720",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6432",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6527",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3553",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.627",
  "onboarding-tours": "/onboarding-tours/static-1.16075",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.12604",
  "ui-addon-teams": "/ui-addon-teams/static-1.21032",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.79",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "ContentUtils": "/ContentUtils/static-1.67181",
  "customer-data-properties": "/customer-data-properties/static-1.50369",
  "forms-ai-lib": "/forms-ai-lib/static-1.3778",
  "forms-utils-lib": "/forms-utils-lib/static-1.11909",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.4702",
  "react-dnd-compat": "/react-dnd-compat/static-1.4289",
  "react-tinymce": "/react-tinymce/static-1.54243",
  "tinymce-config": "/tinymce-config/static-2.53369",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10009",
  "underscore": "/underscore/static-1.8",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.3488",
  "floating-ui": "/floating-ui/static-1.49",
  "react-aria": "/react-aria/static-1.58",
  "tanstack-table": "/tanstack-table/static-1.48",
  "trellis-assets": "/trellis-assets/static-1.911",
  "ui-fonts": "/ui-fonts/static-1.344",
  "dispatcher": "/dispatcher/static-1.129",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.762",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.455",
  "quartz-auth": "/quartz-auth/static-1.200",
  "quartz-head": "/quartz-head/static-1.190",
  "quartz-i18n": "/quartz-i18n/static-1.200",
  "quartz-test": "/quartz-test/static-1.200",
  "batch-promise": "/batch-promise/static-1.1191",
  "external-options-client-types": "/external-options-client-types/static-1.3855",
  "react-colorpicker": "/react-colorpicker/static-2.9878",
  "reporting-insights-lib": "/reporting-insights-lib/static-1.767",
  "copilot-toolkit": "/copilot-toolkit/static-1.10183",
  "data-quality-ui-library": "/data-quality-ui-library/static-1.12012",
  "html-to-image": "/html-to-image/static-1.47",
  "markdown-it": "/markdown-it/static-1.6",
  "reporting-action-components": "/reporting-action-components/static-1.40340",
  "reporting-plugins": "/reporting-plugins/static-1.9796",
  "ui-addon-draggable-compat": "/ui-addon-draggable-compat/static-2.3918",
  "ui-addon-opt": "/ui-addon-opt/static-4.8053",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.9803",
  "zustand": "/zustand/static-1.51",
  "growth-payments-core": "/growth-payments-core/static-1.24334",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4542",
  "sales-templates-service-types-lib": "/sales-templates-service-types-lib/static-1.3867",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.8671",
  "growth-monetization-service-types": "/growth-monetization-service-types/static-1.4198",
  "merchandise-lib": "/merchandise-lib/static-1.253",
  "emoji-regex": "/emoji-regex/static-1.7",
  "feature-store-service-types": "/feature-store-service-types/static-1.4191",
  "purchase-motions-components": "/purchase-motions-components/static-1.5275",
  "salesImages": "/salesImages/static-1.518",
  "ts-schema": "/ts-schema/static-1.3777",
  "upgrade-management-service-types": "/upgrade-management-service-types/static-1.4182",
  "timezone-utils": "/timezone-utils/static-2.4907",
  "bender-build-tools": "/bender-build-tools/static-1.2770",
  "chatspot-core": "/chatspot-core/static-1.19790",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2547",
  "stylex": "/stylex/static-1.25",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3494",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.3838",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3394",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.17465",
  "growth-data-modal": "/growth-data-modal/static-1.4993",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.2716",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.1151",
  "navigation-components": "/navigation-components/static-1.16880",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.4289",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.141",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7184",
  "ui-universal-auth": "/ui-universal-auth/static-1.8498",
  "user-context": "/user-context/static-1.4751",
  "cms-field-types": "/cms-field-types/static-1.4467",
  "content-icons-ui": "/content-icons-ui/static-1.2103",
  "calling-global-api": "/calling-global-api/static-1.63185",
  "calling-internal-common": "/calling-internal-common/static-1.30950",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.64567",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.56861",
  "commerce-products-lib": "/commerce-products-lib/static-1.8429",
  "crm-links": "/crm-links/static-1.5908",
  "file-manager-components": "/file-manager-components/static-1.22491",
  "google-libphonenumber": "/google-libphonenumber/static-1.31",
  "hs-entities": "/hs-entities/static-1.312",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.3922",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.298",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.47507",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.3658",
  "property-value-citations": "/property-value-citations/static-1.983",
  "pulse": "/pulse/static-1.145",
  "smart-property-lib": "/smart-property-lib/static-1.5379",
  "tiered-pricing": "/tiered-pricing/static-1.613",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.8668",
  "final-form": "/final-form/static-1.63",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "rich-text-lib": "/rich-text-lib/static-1.19234",
  "tinymce-themes": "/tinymce-themes/static-1.55339",
  "data-token-picker": "/data-token-picker/static-1.15824",
  "hub-http-contrib": "/hub-http-contrib/static-1.2711",
  "interframe": "/interframe/static-3.4453",
  "tinymce-data": "/tinymce-data/static-1.39454",
  "tinymce-plugins": "/tinymce-plugins/static-1.56483",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.4879",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.9127",
  "magpie-lib": "/magpie-lib/static-1.5237",
  "magpie-types": "/magpie-types/static-1.4697",
  "simple-logging-lib": "/simple-logging-lib/static-1.2714",
  "content-assistance-lib": "/content-assistance-lib/static-1.7250",
  "dashboard-lib": "/dashboard-lib/static-1.80086",
  "ExportDialog": "/ExportDialog/static-6.10051",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.17236",
  "hubspot-prosemirror-plugins": "/hubspot-prosemirror-plugins/static-1.17228",
  "integrations-lib": "/integrations-lib/static-1.14976",
  "prosemirror": "/prosemirror/static-1.13",
  "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.8351",
  "campaign-roi-lib": "/campaign-roi-lib/static-1.7878",
  "feedback-loader": "/feedback-loader/static-1.28619",
  "commerce-analytics-service-client": "/commerce-analytics-service-client/static-1.3346",
  "onboarding-scopes": "/onboarding-scopes/static-1.6106",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4312",
  "nav-client-types": "/nav-client-types/static-1.1996",
  "purchase-motions-api": "/purchase-motions-api/static-1.5278",
  "trials-service-types": "/trials-service-types/static-1.3599",
  "chatspot-client-types": "/chatspot-client-types/static-1.10306",
  "idb-keyval": "/idb-keyval/static-1.37",
  "reactive-lib": "/reactive-lib/static-1.390",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.16583",
  "calling-error-reporting": "/calling-error-reporting/static-1.30956",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.10680",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6203",
  "calling-orchestration-shared-library": "/calling-orchestration-shared-library/static-1.34374",
  "customer-data-tracking": "/customer-data-tracking/static-1.6525",
  "products-iframe-lib": "/products-iframe-lib/static-1.6989",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.9511",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.8118",
  "apollo-dlb": "/apollo-dlb/static-3.80",
  "immerable": "/immerable/static-1.3819",
  "video-components-external": "/video-components-external/static-1.10145",
  "video-data-lib": "/video-data-lib/static-1.33803",
  "directed-graph": "/directed-graph/static-1.598",
  "event-emitter": "/event-emitter/static-1.589",
  "breeze-intelligence-kit": "/breeze-intelligence-kit/static-1.5122",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.9212",
  "fsm": "/fsm/static-1.3393",
  "policy-lib": "/policy-lib/static-1.6466",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.9275",
  "navigation-messaging": "/navigation-messaging/static-1.6207",
  "FileManagerLib": "/FileManagerLib/static-1.38131",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.8775",
  "FileManagerCore": "/FileManagerCore/static-1.37990",
  "codemirror": "/codemirror/static-5.88",
  "layout-dnd-components": "/layout-dnd-components/static-1.11794",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.10769",
  "react-codemirror": "/react-codemirror/static-1.10266",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9555",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.13318",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8386",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.27561",
  "redux-actions": "/redux-actions/static-3.7",
  "knowledge-content-types": "/knowledge-content-types/static-1.8264",
  "payment-link-components": "/payment-link-components/static-1.22561",
  "EmailSignatureEditor": "/EmailSignatureEditor/static-1.23677",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.12391",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5247",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7449",
  "redux-observable": "/redux-observable/static-1.11",
  "ReduxMessenger": "/ReduxMessenger/static-2.10038",
  "rxjs": "/rxjs/static-5.10",
  "eligibility-engine-service-types": "/eligibility-engine-service-types/static-1.2880",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.34599",
  "sales-views-client-types": "/sales-views-client-types/static-1.3955",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3332",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.10866",
  "content-media-compositions": "/content-media-compositions/static-2.14873",
  "media-bridge-lib": "/media-bridge-lib/static-1.18350",
  "trellis-story-utils": "/trellis-story-utils/static-1.4188",
  "storybook-react": "/storybook-react/static-1.26",
  "audio-components": "/audio-components/static-1.5419",
  "FileManagerImages": "/FileManagerImages/static-1.35642",
  "video-components": "/video-components/static-1.12148",
  "cropperjs": "/cropperjs/static-1.10",
  "urlinator": "/urlinator/static-1.4189",
  "video-embed": "/video-embed/static-1.34637",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "ContentData": "/ContentData/static-1.67256",
  "layout-data-lib": "/layout-data-lib/static-1.9094",
  "browser-eslint": "/browser-eslint/static-2.57",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6250",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.5508",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.4752",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3358",
  "draft-convert": "/draft-convert/static-2.31",
  "draft-extend": "/draft-extend/static-2.46",
  "draft-js": "/draft-js/static-5.37",
  "draft-plugins": "/draft-plugins/static-2.21074",
  "sales-email-signature-service-client": "/sales-email-signature-service-client/static-1.3503",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.2660",
  "hls.js": "/hls.js/static-1.32",
  "social-insights-client-types": "/social-insights-client-types/static-1.21028",
  "outpost": "/outpost/static-1.3880",
  "advanced-menus-core": "/advanced-menus-core/static-1.14600",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.11601",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.33052",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.14599",
  "simple-menus-lib": "/simple-menus-lib/static-1.16116"
}
};
